var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['type-item', 'item', {active: _vm.active}],on:{"click":_vm.handleClick}},[(_vm.child && _vm.img)?_c('div',{staticClass:"image-block"},[_c('img',{attrs:{"src":_vm.img}})]):_vm._e(),_c('p',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }